import React from "react";
import RecognitionPage from "../shared/recognition/RecognitionPage";
import {
  EXPENSE_DATA,
  INITIAL_CONTRACT_SETTINGS,
  INITIAL_RECOGNITIONS,
} from "./mock/expenseMock";

const EXPENSE_CONFIG = {
  periodBy: "contract",
  themeClass: "rr-theme--expense",
  documentPrefix: "ПР",
  entry: {
    debit: "Расходы будущих периодов",
    credit: "Кредиторская задолженность",
  },
  texts: {
    noun: "Расходы",
    nounGenitive: "расходов",
    settingsTab: "Настройки договоров",
    totalLabel: "Итого расходов за период",
    detailsCaption: "Признание расходов",
    formTitle: "Создание признания расходов",
    calcTitle: "Расчет расходов",
    submit: "Признать расходы",
    confirmTitle: "Признать расходы?",
    toastTitle: "Расходы признаны",
    note:
      "После подтверждения система сформирует управленческую операцию признания расходов и отразит её в Журнале операций.",
  },
};

function ExpenseRecognition() {
  return (
    <RecognitionPage
      config={EXPENSE_CONFIG}
      data={EXPENSE_DATA}
      initialRecognitions={INITIAL_RECOGNITIONS}
      initialSettings={INITIAL_CONTRACT_SETTINGS}
    />
  );
}

export default ExpenseRecognition;
